export default "__VITE_ASSET__C_I80GBs__"